import { render, staticRenderFns } from "./product-chart.vue?vue&type=template&id=c5d3f484&scoped=true&"
import script from "./product-chart.vue?vue&type=script&lang=js&"
export * from "./product-chart.vue?vue&type=script&lang=js&"
import style0 from "./product-chart.vue?vue&type=style&index=0&id=c5d3f484&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5d3f484",
  null
  
)

export default component.exports